export const es = {
    COMMON: {
        YES: 'Sí',
        ABN: {
            LANGUAGE: {
                SECTION_TITLE: 'Idioma',
            },
            WARNING_BEFORE:
                'Medicare no cubre todo, incluso algunos cuidados que usted o su proveedor de atención médica creen que necesita.',
            WARNING_BOLD: 'Esperamos que Medicare no pague por el artículo, prueba, servicio o cuidado que se indica a continuación.',
            WARNING_AFTER: 'Si Medicare no paga, es posible que usted tenga que pagar.',
            FIELD1: 'Artículo, prueba, servicio o cuidado',
            FIELD2: 'Razón por la que Medicare puede no pagar',
            FIELD3: 'Costo Estimado',
            ADD_ITEM: 'Agregar artículo',
            NEED_TO_KNOW: {
                TITLE: 'Qué hacer ahora',
                ITEM1: 'Lea este aviso para tomar una decisión informada sobre su cuidado.',
                ITEM2: 'Haga cualquier pregunta que tenga.',
                ITEM3: 'Elija una opción a continuación para informarnos si aún desea recibir el artículo, prueba, servicio o cuidado.',
            },
            OPTIONS: {
                SECTION_TITLE: 'Opciones',
                HEADER: 'Elija UNA opción a continuación. No podemos elegir por usted.',
                SUBHEADER:
                    'Si elige la Opción 1 o 2, es posible que le ayudemos a usar cualquier otro seguro que pueda tener, pero Medicare no puede exigirnos que lo hagamos.',
                OPTION1: {
                    LABEL: 'Opción 1',
                    DESCRIPTION_BOLD:
                        'Deseo el artículo, prueba, servicio o cuidado enumerado anteriormente y quiero que se le facture a Medicare por una decisión oficial sobre el pago, que recibiré en un Aviso de Resumen de Medicare (MSN).',
                    DESCRIPTION_NORMAL:
                        'Puede solicitar que se le pague ahora. Entiendo que si Medicare no paga, soy responsable del pago, pero puedo apelar a Medicare siguiendo las instrucciones del MSN. Si Medicare paga, usted reembolsará cualquier pago que le haya hecho, menos copagos o deducibles.',
                },
                OPTION2: {
                    LABEL: 'Opción 2',
                    DESCRIPTION_BOLD: 'Deseo el artículo, prueba, servicio o cuidado enumerado anteriormente, pero no facture a Medicare.',
                    DESCRIPTION_NORMAL:
                        'Puede solicitar que se le pague ahora y soy responsable del pago. Entiendo que no puedo apelar, ya que no se factura a Medicare.',
                },
                OPTION3: {
                    LABEL: 'Opción 3',
                    DESCRIPTION_BOLD: 'No deseo el artículo, prueba, servicio o cuidado enumerado anteriormente.',
                    DESCRIPTION_NORMAL: 'Entiendo que no soy responsable del pago y no puedo apelar para ver si Medicare pagaría.',
                },
            },
            ADDITIONAL_INFORMATION: {
                SECTION_TITLE: 'Información adicional',
                NOTES_PLACEHOLDER: 'Complete la información adicional si la hay',
                ITEM1: 'Este aviso da nuestra opinión, no es una decisión oficial de Medicare.',
                ITEM2: 'Si tiene otras preguntas sobre este aviso o la facturación de Medicare, llame al 1-800-MEDICARE (1-800-633-4227/ TTY: 1-877-486-2048).',
                ITEM3: 'Firmar a continuación significa que ha recibido y comprende este aviso. Puede solicitar recibir una copia.',
                ITEM4: 'Tiene derecho a obtener información de Medicare en un formato accesible, como letra grande, braille o audio. También tiene derecho a presentar una queja si siente que ha sido discriminado. Visite Medicare.gov/about-us/accessibility-nondiscrimination-notice.',
            },
            EFFECTIVE_DATE: {
                SECTION_TITLE: 'Fecha de Vigencia',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Firma del paciente o representante autorizado',
                AGREE: 'El paciente o representante autorizado acepta firmar este documento electrónicamente con una firma electrónica al marcar esta casilla.',
                AUTHORIZED_REP:
                    'Marque aquí si está firmando como Representante Autorizado y asegúrese de que su nombre sea legible o imprima su nombre si no lo es.',
                AUTHORIZED_REP_NAME_LABEL: 'Nombre del representante autorizado',
                AUTHORIZED_REP_NAME_PLACEHOLDER: 'Nombre y apellido',
                AUTHORIZED_REP_FALLBACK: 'Representante Autorizado',
            },
            COMPLETE: 'Completar',
        },
        NOMNC: {
            LANGUAGE: {
                SECTION_TITLE: 'Idioma',
            },
            SERVICE_TYPE: {
                SECTION_TITLE: 'Tipo de Servicio',
                LABEL: 'Tipo de servicio que se termina',
                PLACEHOLDER:
                    'p. ej., enfermería especializada, atención domiciliaria, servicio integral de rehabilitación ambulatoria u hospicio',
                OTHER_LABEL: 'Por favor especifique',
                OTHER_PLACEHOLDER: 'Describa otro tipo de servicio',
            },
            WARNING:
                'Su proveedor y/o plan de salud determinó que Medicare probablemente no pagará por sus servicios indicados a continuación después de la fecha indicada. Es posible que tenga que pagar por los servicios que reciba después de esta fecha.',
            EFFECTIVE_DATE: {
                SECTION_TITLE: 'Fecha Efectiva',
                LABEL: 'Fecha de finalización de la cobertura',
            },
            QIO: {
                SECTION_TITLE: 'Organización para el Mejoramiento de Calidad (QIO)',
                LABEL: 'Nombre y número gratuito de la QIO',
                NAME_LABEL: 'Nombre de la QIO',
                PHONE_LABEL: 'Número gratuito de la QIO',
            },
            APPEAL: {
                SECTION_TITLE: 'Su Derecho a Apelar Esta Decisión',
                ITEM1: 'Usted tiene derecho a apelar la decisión de finalizar la cobertura de Medicare de sus servicios. Esto significa que obtendrá una revisión médica independiente de inmediato. Sus servicios continuarán durante la apelación.',
                ITEM2: 'Si decide apelar, el revisor independiente le pedirá su opinión. No tiene que preparar nada por escrito, pero tiene derecho a hacerlo si desea. El revisor además examinará sus expedientes médicos y/u otra información relevante.',
                ITEM3: 'Una vez que solicite una apelación, recibirá un aviso con una explicación detallada del motivo por el que debe finalizar su cobertura del servicio.',
                ITEM4: 'Si el revisor independiente está de acuerdo con que la cobertura de Medicare de sus servicios debe finalizar, ni Medicare ni su plan pagará esos servicios después de la fecha antes indicada.',
                ITEM5: 'Si usted pone fin a los servicios antes de la fecha antes indicada, evitará la responsabilidad económica.',
            },
            HOW_TO_APPEAL: {
                SECTION_TITLE: 'Cómo Solicitar una Apelación Inmediata',
                ITEM1: 'Solicite la apelación lo antes posible. Debe solicitar una apelación a tiempo y forma antes del mediodía del día anterior a la fecha antes indicada.',
                ITEM2: 'Haga su solicitud a su Organización para el Mejoramiento de Calidad (QIO, por sus siglas en inglés). Una QIO es el revisor independiente autorizado por Medicare.',
                ITEM3: 'Si no cumple con la fecha límite para solicitar una apelación inmediata, es posible que aún tenga derechos de apelación.',
                ITEM4: 'Llame a su QIO {{qioName}}, al {{qioPhone}} para apelar, o si tiene preguntas.',
            },
            WHAT_HAPPENS: {
                SECTION_TITLE: 'Qué Ocurre Después',
                ITEM1: 'La QIO le notificará de su decisión lo antes posible; por lo general, será como máximo dos días después de la fecha efectiva antes indicada. Si está en un plan de salud de Medicare, generalmente la QIO le informará su decisión antes de la fecha efectiva antes indicada.',
                ITEM2: 'Llame a su QIO, {{qioName}}, al {{qioPhone}} para obtener más información.',
            },
            ADDITIONAL_INFORMATION: {
                SECTION_TITLE: 'Información Adicional (Opcional)',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Firma del Paciente o Representante',
                AGREE: 'Me han notificado que la cobertura de mis servicios finalizará en la fecha de este aviso y que puedo apelar esa decisión si contacto a mi QIO.',
                DATE_LABEL: 'Fecha',
            },
        },
        HHCCN: {
            LANGUAGE: {
                SECTION_TITLE: 'Idioma',
            },
            CHANGES: {
                SECTION_TITLE: 'Aviso de cambio de cuidado de salud en el hogar (HHCCN)',
                FIELD1: '¿Qué artículos/servicios están cambiando?',
                FIELD2: 'Razón por el cambio',
                ADD_ITEM: 'Agregar artículo',
            },
            STARTING_DATE: {
                SECTION_TITLE: 'Fecha de inicio',
                LABEL: 'Fecha en que comienzan los cambios',
            },
            NOTICE_REASON: {
                SECTION_TITLE: '¿Por qué recibió este aviso?',
                OPTION1: {
                    LABEL: 'Su médico/proveedor cambió (o no renovó) la orden de su cuidado en el hogar.',
                    DESCRIPTION:
                        'La agencia de cuidado de salud en el hogar debe seguir las órdenes del médico/proveedor para brindarle atención. Si no está de acuerdo con este cambio, hable con su agencia de cuidado de salud en el hogar o con el médico/proveedor que solicita su cuidado.',
                },
                OPTION2: {
                    LABEL: 'Su agencia de cuidado de salud en el hogar decidió dejar de brindarle los artículos/servicios por los motivos mencionados anteriormente.',
                    DESCRIPTION:
                        'Si cree que aún necesita cuidado de salud en el hogar, puede buscar atención en otra agencia de cuidado si tiene una orden válida. Para obtener ayuda para encontrar una agencia de cuidado de salud en el hogar diferente, comuníquese con el médico/proveedor que ordenó su cuidado.',
                },
            },
            GET_HELP: {
                SECTION_TITLE: 'Obtener ayuda o más información',
                CONTENT:
                    'Si tiene preguntas sobre estos cambios, comuníquese con su agencia de cuidado de salud en el hogar y/o el médico/proveedor que ordena su cuidado en el hogar. No puede apelar a Medicare sobre el pago de los artículos/servicios mencionados anteriormente a menos que reciba los artículos/servicios y se presente un reclamo a Medicare.',
            },
            OPTIONAL_DETAILS: {
                SECTION_TITLE: 'Detalles opcionales',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Firma',
                HEADING: 'Firme a continuación para mostrar que comprende este aviso',
                AGREE: 'El paciente o representante autorizado acepta firmar este documento electrónicamente con una firma electrónica al marcar esta casilla.',
                AUTHORIZED_REP:
                    'Marque aquí si está firmando como Representante Autorizado y asegúrese de que su nombre sea legible o imprima su nombre si no lo es.',
            },
            ACCESSIBILITY: {
                CONTENT:
                    'Tiene derecho a obtener su información en un formato accesible, como letra grande, braille o audio. También tiene derecho a presentar una queja si siente que ha sido discriminado. Visite Medicare.gov/about-us/accessibility-nondiscrimination-notice, o llame al 1-800-MEDICARE (1-800-633-4227) para obtener más información. Los usuarios de TTY pueden llamar al 1-877-486-2048.',
            },
        },
        PATIENT_CONSENT: {
            LANGUAGE: {
                SECTION_TITLE: 'Idioma',
            },
            I_CONSENT: 'Yo consiento',
            I_DO_NOT_CONSENT: 'Yo no consiento',
            REQUEST: {
                SECTION_TITLE: 'Solicitud de evaluación inicial/admisión/consentimiento para tratamiento',
                CONTENT:
                    'Por la presente solicito y acepto la evaluación inicial y, si puedo ser admitido en {{agencyNameComplete}} (en adelante {{agencyName}}), doy mi consentimiento para que el personal autorizado de {{agencyName}} realice todos los procedimientos y tratamientos necesarios ordenados por mis médicos para mi atención de salud en el hogar. Entiendo que mi atención es dirigida y supervisada por mi médico, quien no es empleado ni agente de {{agencyName}}, y {{agencyName}} no es responsable de ningún acto u omisión al seguir las instrucciones del médico.',
            },
            CLIENT_RIGHTS: {
                SECTION_TITLE: 'Derechos y responsabilidades del cliente',
                CONTENT:
                    'Entiendo mis Derechos y Responsabilidades. He recibido un aviso escrito de mis Derechos y Responsabilidades y la Declaración de la Ley de Privacidad del Paciente de OASIS, y el Aviso de Prácticas de Privacidad antes de ser atendido por el personal de {{agencyName}} .',
            },
            ADVANCE_DIRECTIVE_RESUSCITATION: {
                SECTION_TITLE: 'Voluntades anticipadas/Reanimación',
                CONTENT:
                    'Soy consciente de que si no tengo, o no presento, una copia debidamente ejecutada de una directiva anticipada, {{agencyName}} estará obligada a realizar una reanimación cardiaca y a llamar a los paramédicos si mi estado indica la necesidad de dicha intervención.',
            },
            COMPLAINTS: {
                SECTION_TITLE: 'Registro de denuncias',
                CONTENT:
                    'Estoy de acuerdo en notificar a una Enfermera Registrada de {{agencyName}} si tengo una queja. Entiendo que si la Enfermera Registrada no resuelve la queja, yo o un miembro de mi familia debemos registrar la queja por escrito al Administrador. Entiendo que cada persona a la que se dirija mi queja por escrito debe responder a la queja dentro de los cinco (5) días hábiles posteriores a la recepción de la queja escrita.',
            },
            HOTLINE: {
                SECTION_TITLE: 'Línea directa',
                CONTENT:
                    'Se me ha proporcionado información e instrucciones sobre los procedimientos de resolución de quejas de {{agencyName}}. Como paciente, entiendo que tengo el derecho de presentar una queja ante el Departamento de Salud y Servicios Humanos de la División de Salud Pública y Conductual de Nevada (DPBH) sin ser sujeto a discriminación o represalias. La línea directa es 1-800-225-3414, disponible las 24 horas del día. Entiendo que también tengo el derecho de utilizar esta línea directa para presentar quejas relacionadas con la implementación de los requisitos de directivas anticipadas. También puedo contactar a:',
                NAME: 'Nombre de la línea directa: {{name}}',
                PHONE: 'Teléfono directo: {{phone}}',
                ADDRESS: 'Dirección de la línea directa: {{address}}',
            },
            AUTH_RELEASE: {
                SECTION_TITLE: 'Autorización para divulgar información',
                CONTENT:
                    'Doy mi consentimiento para la divulgación de cualquier información relacionada con mi condición médica por parte de cualquier agencia de salud reconocida, institución o grupo/oficina médica en la que haya sido paciente, y autorizo la liberación y/o divulgación de cualquier expediente médico o información por parte de los anteriores a {{agencyName}} y a aquellos involucrados en mi atención mientras esté admitido en {{agencyName}}. Entiendo que mis expedientes médicos pueden ser revelados a organismos acreditadores federales y estatales, y por los Comités de Gestión de Calidad/Revisión de Utilización de {{agencyName}}.',
                NOT_ALLOWED: 'Información no puede ser divulgada sobre',
                NOT_RELEASED_TO: 'Información no puede ser divulgada a',
            },
            PAYMENT_REQUEST: {
                SECTION_TITLE: 'Solicitud de pago/asignación de prestaciones',
                CONTENT:
                    'Certifico que toda la información de pago de Medicare, HMO, Medicaid o cualquier otro seguro médico proporcionada a {{agencyName}} es verdadera y precisa, y autorizo a {{agencyName}} a solicitar el pago en mi nombre. Autorizo la divulgación de todos los registros que puedan ser necesarios para asegurar el pago. Entiendo que debo notificar a {{agencyName}} de inmediato sobre cualquier cambio en mi cobertura médica, incluyendo Medicare y Medicaid. También entiendo que si cambio de seguro médico mientras estoy bajo el cuidado de {{agencyName}}, seré responsable de cualquier cambio no cubierto como resultado del cambio en la cobertura. Por la presente, autorizo a {{agencyName}} a usar y/o divulgar mi información de salud para tratamiento, pago, operaciones de atención médica y coordinaciones.',
            },
            MEDICARE_PATIENTS: {
                SECTION_TITLE: 'Pacientes de Medicare',
                CONTENT:
                    'Entiendo que {{agencyName}} acepta todas las Partes A y B de Medicare como pago total por todos los servicios de enfermería especializada y rehabilitación y que se me notificará, por adelantado, si hay cargos por equipos y suministros médicos.',
                CONTENT2:
                    'Soy consciente de que soy responsable de cualquier coste no cubierto, parte del coste o copago en contraprestación por los servicios que voy a recibir. hará todos los intentos razonables para recaudar estos pagos. Los cargos previstos incluyen:',
                SNCHARGE: '${{charge}} por visita de 1 hora para SN',
                PTCHARGE: '${{charge}} por visita de 1 hora para PT',
                OTCHARGE: '${{charge}} por visita de 1 hora para OT',
                STCHARGE: '${{charge}} por visita de 1 hora para ST',
                MSWCHARGE: '${{charge}} por visita de 1 hora para MSW',
                HHACHARGE: '${{charge}} por visita de 1 hora para HHA',
            },
            PROPOSE_SERVICES: {
                SECTION_TITLE: 'Servicios propuestos y frecuencia de las visitas',
                CONTENT:
                    'He estado activamente involucrado en la planificación de mi atención con {{agencyName}} y entiendo que los siguientes servicios y visitas serán proporcionados si son necesarios y aprobados por mi médico:',
                CONTENT2: 'Se requiere al menos un servicio.',
            },
            ADVANCE_DIRECTIVE: {
                SECTION_TITLE: 'Voluntades anticipadas',
                ITEM1: 'He completado una Directiva Anticipada.',
                ITEM2: 'Tengo un Poder Notarial Duradero para el Cuidado de la Salud.',
                ITEM3: 'Tengo un testamento vital.',
                ITEM4: 'Tengo una Directiva de NO Resucitar.',
                ITEM5: 'Otro (explique).',
                ITEM6: 'No sé si tengo alguno de los anteriores.',
                ITEM7: 'Entiendo que debo proporcionar una copia de cualquiera de estos documentos para que se respeten mis deseos en relación con mi atención médica.',
                ITEM8: 'Copia obtenida para el expediente',
                ITEM9: 'Orden Médica para Tratamiento de Soporte Vital (POLST)',
                ITEM10: 'Orden Médica para Tratamiento de Soporte Vital (MOLST)',
                ITEM11: 'Otro documento legalmente válido bajo la ley estatal',
                ITEM12: 'Tomador de decisiones sustituto',
                ITEM13: 'Si alguna de la siguiente información está documentada en el plan de atención anticipada del paciente, especifique a continuación:',
                ITEM14: 'Preferencias de tratamiento médico',
                ITEM15: 'Preferencias de salud mental/conductual',
                ITEM16: 'Preferencias culturales/sociales',
                ITEM17: 'Preferencias espirituales/religiosas',
            },
            PRIVACY_NOTICE: {
                SECTION_TITLE: 'Aviso de Privacidad',
                ITEM1: 'Declaración de la Ley de Privacidad de OASIS – Confidencialidad y acceso a los registros de atención médica.',
                ITEM2: 'Se me ha informado y se me ha dado un aviso por escrito de la Declaración de la Ley de Privacidad de OASIS para informarme de mis derechos, los propósitos principales, los usos rutinarios y lo que puede resultar si no proporciono información precisa para completar OASIS. Se me ha proporcionado información sobre la confidencialidad y la divulgación de mis registros clínicos mantenidos por {{agencyName}}. Se me ha proporcionado información sobre cómo recuperar y obtener una copia de mis registros médicos mantenidos por {{agencyName}}.',
                ITEM3: 'La información sobre Seguridad/Preparación para Emergencias/Control de Infecciones y Precauciones Universales/Protocolo 911 y síntomas a reportar al médico me es proporcionada durante la evaluación inicial y de manera continua según sea necesario.',
            },
            PHOTO_CONSENT: {
                SECTION_TITLE: 'Consentimiento para fotografiar',
                CONTENT:
                    'al personal de {{agencyName}} tomar fotografías de las partes correspondientes de mi cuerpo con el fin de proporcionar documentación de apoyo sobre mi condición médica (entiendo que cualquier fotografía tomada se colocará y permanecerá como parte de mi expediente médico).',
            },
            HIPPA: {
                SECTION_TITLE: 'Health Insurance Portability and Accountability Act (HIPAA)',
                CONTENT:
                    'Permiso para Usar y Divulgar su Información de Salud: Al firmar este consentimiento, autorizo a {{agencyName}} a usar y/o divulgar mi información de salud para tratamiento, pago u operaciones de atención médica. Tengo el derecho de no firmar este consentimiento. Sin embargo, si me niego a firmar este consentimiento, {{agencyName}} tiene el derecho de negarme el servicio.',
            },
            PATIENT_RIGHTS: {
                SECTION_TITLE: 'Derechos del paciente',
                CONTENT: 'Como paciente, usted tiene los siguientes derechos. debe proteger y promover el ejercicio de estos derechos.',

                ITEM0: '{{agencyName}} debe proporcionarle una notificación por escrito de estos derechos, que incluye la Declaración de Derechos de Privacidad del Paciente de OASIS, la Declaración de la Ley de Privacidad y el Aviso de Prácticas de Privacidad antes de prestar atención o durante los procedimientos de evaluación inicial.',

                ITEM1: 'Usted tiene derecho a ser tratado con consideración, respeto y pleno reconocimiento de su dignidad e individualidad, a recibir servicios de salud en el hogar apropiados y profesionales sin discriminación por su raza, religión, género, edad, credo, estado civil, estatus político, orientación sexual, diagnóstico o fuente de pago, y a tener la seguridad de que el personal que brinda atención está calificado a través de la educación y la experiencia para llevar a cabo los servicios de los cuales es responsable.',

                ITEM2: 'Tiene derecho a recibir servicios adecuados a sus necesidades, y a ser informado sobre la naturaleza y el propósito de todos los servicios especializados y no especializados, los procedimientos técnicos que se realizarán, incluyendo información sobre los beneficios y cargas potenciales, así como cuándo y quién realizará los procedimientos. También puede esperar que {{agencyName}} le proporcione atención segura y profesional al nivel requerido de intensidad.',

                ITEM3: 'Tiene derecho a recibir una continuidad razonable de atención.',

                ITEM4: 'Tiene derecho a que el personal se comunique en un idioma o formato que usted pueda entender razonablemente (cuando sea posible, {{agencyName}} le asistirá o proporcionará dispositivos especiales, intérpretes u otras ayudas para facilitar la comunicación).',

                ITEM5: 'Su familia o tutor puede ejercer sus derechos a través de un Poder Notarial Duradero para el Cuidado de la Salud, si usted no puede tomar decisiones por sí mismo.',

                ITEM6: 'Tiene derecho a que su propiedad sea tratada con respeto.',

                ITEM7: 'Tiene derecho a expresar quejas sobre el tratamiento o la atención que se le brinda (o que no se le brinda), o con respecto a la falta de respeto por su propiedad, sin represalias o discriminación por lo mismo, y a ser informado del procedimiento para expresar quejas/reclamaciones con {{agencyName}}.',

                ITEM8: '{{agencyName}} debe investigar cualquier queja realizada por usted, su familia o su tutor con respecto a cualquier reclamación que usted pueda tener, y {{agencyName}} debe documentar la existencia y el resultado de dichas quejas.',

                ITEM9: 'Tiene derecho a ser informado con antelación sobre la atención que se le brindará.',

                ITEM10: '{{agencyName}} debe informarle con antelación sobre las disciplinas que brindarán atención médica y la frecuencia de las visitas propuestas.',

                ITEM11: '{{agencyName}} debe informarle de cualquier cambio en el plan de atención antes de que se realice el cambio.',

                ITEM12: 'Tiene derecho a participar en la planificación de su atención.',

                ITEM13: 'Tiene derecho a rechazar el tratamiento y a ser informado de las consecuencias de dicho rechazo.',

                ITEM14: 'Tiene derecho a rechazar cualquier tratamiento experimental y/o participar en investigaciones a menos que usted otorgue su consentimiento voluntario documentado.',

                ITEM15: '{{agencyName}} debe informarle y proporcionarle información por escrito con anticipación sobre su política en relación con las Directrices Anticipadas e incluir una descripción de la ley del estado de Nevada.',

                ITEM16: '{{agencyName}} le proporcionará la información durante la evaluación.',

                ITEM17: 'Tiene derecho a que sus registros médicos, que son mantenidos por {{agencyName}}, permanezcan confidenciales.',

                ITEM18: 'Tiene derecho a aprobar o desaprobar por escrito la divulgación de sus registros médicos a cualquier persona empleada fuera de {{agencyName}}.',

                ITEM19: '{{agencyName}} debe informarle sobre sus políticas y procedimientos con respecto a la divulgación de registros médicos.',

                ITEM20: 'Usted o su representante legal tienen derecho a obtener una copia de sus registros médicos dando a {{agencyName}} un aviso con tres (3) días de antelación.',

                ITEM21: 'Se le cobrará 40 centavos por página.',

                ITEM22: 'Tiene derecho a ser informado, antes de que se inicie la atención, de la medida en que se espera el pago por los servicios de {{agencyName}} por parte de Medicare u otras fuentes, y la medida en que puede requerirse el pago de su parte.',

                ITEM23: 'Antes de iniciar la atención, {{agencyName}} debe informarle verbalmente o por escrito sobre: Cargos por servicios y Equipos Médicos Duraderos (DME) que no serán cubiertos por Medicare. Cargos por servicios y Equipos Médicos Duraderos (DME) que usted puede tener que pagar. Tiene derecho a ser informado verbalmente y por escrito de cualquier cambio en la información sobre el pago dentro de los 30 días desde la fecha en que {{agencyName}} tenga conocimiento de dichos cambios.',

                ITEM24: 'Tiene derecho a revisar una copia del Aviso de Prácticas de Privacidad de {{agencyName}} antes de firmar este consentimiento.',

                ITEM25: 'El Aviso de Prácticas de Privacidad de {{agencyName}} detalla cómo {{agencyName}} puede usar y divulgar su información de salud.',

                ITEM26: '{{agencyName}} puede modificar el Aviso de vez en cuando.',

                ITEM27: 'Una copia de nuestro Aviso de Prácticas de Privacidad está incluida en su Registro en el Hogar.',

                ITEM28: 'Tiene derecho a solicitar que {{agencyName}} restrinja el uso y/o la divulgación de sus registros médicos para el propósito de proporcionar tratamiento, obtener el pago por nuestros servicios y/o llevar a cabo operaciones de atención médica.',

                ITEM29: 'Dichas solicitudes deben hacerse por escrito.',

                ITEM30: 'Tenga en cuenta que {{agencyName}} no está obligada a aceptar cualquier restricción que usted pueda solicitar.',

                ITEM31: 'Sin embargo, si {{agencyName}} decide aceptar una restricción que usted ha solicitado, {{agencyName}} debe restringir el uso y/o la divulgación de sus registros médicos de la manera descrita en su solicitud.',

                ITEM32: 'Para obtener un formulario de solicitud de restricción, comuníquese con {{agencyName}}.',

                ITEM33: 'Tiene derecho a revocar este consentimiento en cualquier momento.',

                ITEM34: 'Su revocación de este consentimiento debe ser por escrito.',

                ITEM35: 'Si desea revocar este consentimiento, comuníquese con {{agencyName}} para obtener un formulario de revocación.',

                ITEM36: 'Tenga en cuenta que su revocación de este consentimiento no será efectiva para las divulgaciones que {{agencyName}} ya haya realizado basándose en su consentimiento previo.',

                ITEM37: '{{agencyName}} también se reserva el derecho de negarse a brindar más tratamiento si usted revoca este consentimiento.',

                ITEM38: 'Este consentimiento es efectivo a menos que y hasta que usted lo revoque por escrito.',

                ITEM39: 'AUTODETERMINACIÓN · USTED TIENE DERECHO A:',

                ITEM40: 'Rechazar el tratamiento y ser informado de las consecuencias esperadas de dicha acción.',

                ITEM41: 'Que la agencia cumpla con las directivas anticipadas según lo permitido por la ley estatal y sus requisitos.',

                ITEM42: 'Recibir atención independientemente de si tiene o no una directiva anticipada.',

                ITEM43: 'Ser informado sobre las políticas y procedimientos de la organización para implementar las directivas anticipadas.',

                ITEM44: 'Recibir información sobre los aspectos de su condición que se relacionan con la atención proporcionada por la agencia y participar en las decisiones sobre su atención.',

                ITEM45: 'Negarse a participar en tratamientos experimentales o investigaciones.',

                ITEM46: 'Participar en la consideración de cuestiones éticas que surjan en su atención.',

                ITEM47: 'Tomar decisiones informadas sobre su atención.',
            },
            PATIENT_RESPONSIBLITY: {
                SECTION_TITLE: 'Responsabilidades del paciente',
                CONTENT: 'Como paciente, tiene las siguientes responsabilidades.',
                ITEM0: 'Permanecer bajo el cuidado de un médico mientras recibe servicios de {{agencyName}}.',

                ITEM1: 'Proporcionar a {{agencyName}} información completa y precisa de salud y de OASIS.',

                ITEM2: 'Firmar el consentimiento requerido antes de que se administre o reciba la atención.',

                ITEM3: 'Proporcionar un ambiente seguro para el personal de {{agencyName}}.',

                ITEM4: 'Tratar al personal de {{agencyName}} con respeto y consideración.',

                ITEM5: 'Notificar a {{agencyName}} cuando no pueda asistir a sus citas.',

                ITEM6: 'Cumplir con un plan de tratamiento mientras esté bajo el cuidado de {{agencyName}} y entender que el incumplimiento puede resultar en su alta de {{agencyName}}.',

                ITEM7: 'Participar y seguir su plan de atención.',

                ITEM8: 'Proporcionar a {{agencyName}} una copia de las Directrices Anticipadas, si es aplicable.',

                ITEM9: 'Proporcionar al personal evaluador los datos de OASIS según lo requerido por Medicare y consentir que {{agencyName}} transmita los datos de OASIS a CMS (HCFA) (Se le proporcionará una copia de la Declaración de Derechos de Privacidad de OASIS y la Declaración de la Ley de Privacidad antes del inicio de la atención).',
            },
            CONTACT: {
                SECTION_TITLE: 'Contacto',
                AVAILIBILITY: 'Puede comunicarse con un representante de:',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: 'Firma',
                CONTENT:
                    'El paciente o representante autorizado acepta firmar este documento electrónicamente con una firma electrónica al marcar esta casilla.',
            },
            COMPLETE: 'Completar',
        },
        FORM_TITLE: {
            'route-sheet': 'Route Sheet',
            abn: 'ABN',
            'patient-consent': 'Patient Consent',
            'physician-order': 'Physician Order',
            'lvn-supervisory': 'LVN Supervisory',
            'hha-supervisory': 'HHA Supervisory',
            'face-to-face': 'Face to Face',
            'discharge-summary': 'Discharge Summary',
            'sixty-day-summary': 'Sixty Day Summary',
            'patient-choice': 'Patient Choice',
            nomnc: 'NOMNC',
            hhccn: 'HHCCN',
        },
    },
};
